import { Icone } from '@/components/ui/Icone'

/**
 * La chaîne WhatsApp d'Haicademy — [DECISIONS §313].
 *
 * **Sous la connexion, pas au-dessus.** Le premier travail de cet écran est de
 * faire entrer le candidat : tout ce qui se place avant le formulaire lui
 * dispute l'attention. En dessous, la chaîne s'adresse à qui hésite encore, à
 * qui vient de créer son compte, et à qui revient sans avoir décidé de payer.
 *
 * **Ce qu'elle promet est ce qui la fait suivre.** « Rejoins notre chaîne » ne
 * dit rien ; « des coupons gratuits chaque semaine et chaque mois » dit
 * exactement ce qu'on y gagne. En Haïti, où l'abonnement se paie par MonCash et
 * où la question du prix décide de l'inscription, c'est la phrase qui compte.
 *
 * **Une chaîne, pas un groupe** : la diffusion va dans un seul sens, personne
 * n'y voit le numéro de personne, et un candidat peut la suivre sans exposer le
 * sien. C'est ce qui la rend proposable depuis un écran public.
 */

/** L'adresse de la chaîne, vérifiée : `og:title` rend bien « Haicademy ». */
export const CHAINE = 'https://whatsapp.com/channel/0029Vb8qszh84Om6HKts7c1X'

export function ChaineWhatsApp() {
  return (
    <a
      href={CHAINE}
      /*
       * **`noopener` n'est pas décoratif.** Sans lui, la page ouverte reçoit une
       * référence vers la nôtre par `window.opener` et peut la faire naviguer
       * ailleurs — un écran de connexion remplacé par une imitation, sans que
       * le candidat ait rien vu. `noreferrer` évite en plus d'annoncer d'où il
       * vient.
       */
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-3 rounded-2xl border p-4 no-underline"
      style={{ borderColor: 'var(--bordure)', color: 'var(--texte-1)' }}
    >
      <span style={{ color: 'var(--accent)' }}>
        <Icone nom="whatsapp" taille={22} />
      </span>

      <span className="flex flex-col gap-1">
        <span className="text-[15px] font-bold">Rejoins notre chaîne WhatsApp</span>

        <span className="text-[14px]" style={{ color: 'var(--texte-2)' }}>
          Nous y distribuons gratuitement des coupons chaque semaine et chaque mois.
        </span>

        {/* Le nom de la chaîne, pour qu'on la reconnaisse une fois arrivé :
            WhatsApp affiche une liste, et « Haicademy » y est ce qu'on cherche. */}
        <span className="text-[13px] font-bold" style={{ color: 'var(--accent)' }}>
          Haicademy
        </span>
      </span>
    </a>
  )
}
